export const REGEXP = {
    Phone: /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/,
    Password: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/,
    Uppercase: /[A-Z]/,
    Lowercase: /[a-z]/,
    Numbers: /[0-9]/,
    SpecialChars: /[!@#$%^&*(),.?":{}|<>]/,
    VentureId: /^[a-zA-Z0-9-_]{3,50}$/,
    PostalCode: /^[a-zA-Z0-9-\s]{3,12}$/,
};
